<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <h1>
                        Edit {{ user.name }}
                    </h1>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
                            <label>
                                Name
                            </label>
                            
                            <b-form-input
                                type="text"
                                v-model="form.name"
                                required
                                placeholder="Name">    
                            </b-form-input>

                            <label>
                                Role
                            </label>

                            <b-form-select 
                                class="mb-2"
                                v-model="form.role" 
                                :options="role_options"
                                required>
                            </b-form-select>

                            <label>
                                Email
                            </label>
                            
                            <b-form-input
                                type="email"
                                v-model="form.email"
                                required
                                placeholder="Email">    
                            </b-form-input>
                        </b-form-group>

                        <b-button type="submit" variant="primary">
                            Submit
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import userRepository from "@/repository/users";

    export default {
        props: ['id'],

        data(){
            return{
                user: null,
                loaded: false,
                role_options: [
                    'ADMIN',
                    'CLIENT'
                ]
            }
        },

        computed: {
            form() {
                return {
                    ...this.user
                }
            }
        },

        methods: {
            onSubmit() {
                userRepository.update(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'User Edited',
                            text: 'New user successfully edited.'
                        });
                    }).catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });
            }
        },

        mounted() {
            userRepository.getById(this.id)
                .then(response => {
                    this.user = response.data;
                    this.loaded = true;
                });
        }
    }
</script>

<style scoped lang="scss">

</style>